import aadhaarScanner from './aadhaarScanner';

export default {aadhaarScanner};